import Router from 'next/router';

import { PATH } from '../../config';
import { connectMQTT } from '../../service/mqtt';
import repo from '../../service/repository';
import storage from '../../service/storage';
import { getLoginState } from '../../utils/login-state';
import { checkCreditCardBinding, login } from '../common-methods';

const Methods = (get) => {
  return {
    login,
    splash: async () => {
      const loginState = getLoginState();
      const { error, data } = await repo.fetchBootstraps();
      if (error) return get().showFailMessage(error);
      get().updateBootstrap(data);

      const whiteListPath = [
        PATH.SHORTCUT_INSTRUCTION,
        PATH.MAPS,
        PATH.SERVICES,
      ];

      const redirect = (defaultPath) => {
        const isWhiteListPath = whiteListPath.some((path) =>
          Router.asPath.includes(path),
        );
        return { path: isWhiteListPath ? `${Router.asPath}` : defaultPath };
      };

      switch (loginState) {
        case 'user':
          return login(
            async (payload) => {
              get().updateApp(payload);
              connectMQTT(get(), {
                client: payload.me.id,
                password: storage.getAuth().accessToken,
              });

              // 確認是否是從 mochipay gateway 的 fallback
              const { path, paymentBindingFail } =
                await checkCreditCardBinding(get);

              if (path) {
                return { path, paymentBindingFail };
              }

              const truePath = Router.asPath.split('?')[0];
              return {
                path: truePath === '/' ? PATH.MAIN : `${Router.asPath}`,
              };
            },
            (error) => {
              console.log(error);
              return redirect(PATH.USER_WELCOME);
            },
          );
        case 'skip':
          return redirect(PATH.MAIN);
        default:
          return {
            path:
              Router.asPath === PATH.USER_LOGIN
                ? PATH.USER_LOGIN
                : PATH.USER_WELCOME,
          };
      }
    },
  };
};

export default Methods;
